import { Link } from "react-router-dom";

const LOGO_MARK = "https://customer-assets.emergentagent.com/job_before-the-loss-1/artifacts/hyk3lwcd_514CC5D3-9081-44D7-8DD9-B78FADD7368F.png";

const LINKS = [
  { label: "Home", href: "/" },
  { label: "Risk Readiness Score", href: "/risk-score" },
  { label: "About", href: "/about" },
  { label: "Services", href: "/services" },
  { label: "Cybersecurity & AI", href: "/topics/business-operations" },
  { label: "Insights", href: "/insights" },
  { label: "Partner Network", href: "/partners" },
  { label: "Contact", href: "/contact" },
];

export const Footer = () => {
  return (
    <footer className="relative bg-black border-t border-white/5" data-testid="site-footer">
      <div className="btr-hairline" />
      <div className="max-w-7xl mx-auto px-6 py-14">
        <div className="grid md:grid-cols-[1.4fr_1fr_1fr] gap-10">
          <div>
            <img
              src={LOGO_MARK}
              alt="Before The Risk"
              className="h-20 w-auto object-contain"
            />
            <p className="font-display font-semibold text-white text-base mt-5 max-w-sm leading-snug" data-testid="footer-tagline">
              Before the loss. Before the litigation. <span className="text-[#a2020b]">Before the risk.</span>
            </p>
            <p className="font-body text-zinc-500 text-sm mt-3 max-w-sm leading-relaxed">
              Risk Management • Loss Consulting • Pre-Loss Protection
            </p>
            <div className="flex items-center gap-2 mt-4">
              <span className="font-display text-[11px] tracking-[0.25em] uppercase text-zinc-500">Florida &amp; Georgia</span>
            </div>
          </div>

          <div>
            <div className="font-display text-[11px] tracking-[0.3em] uppercase text-zinc-500">Navigate</div>
            <ul className="mt-4 space-y-2">
              {LINKS.map((l) => (
                <li key={l.href}>
                  <Link to={l.href} className="font-body text-sm text-zinc-400 hover:text-[#a2020b] transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="font-display text-[11px] tracking-[0.3em] uppercase text-zinc-500">Practice</div>
            <ul className="mt-4 space-y-2 text-sm font-body text-zinc-400">
              <li>Pre-Loss Property Reports</li>
              <li>Litigation-Ready Documentation</li>
              <li>HOA &amp; Commercial Consulting</li>
              <li>Attorney Support</li>
              <li>Cybersecurity &amp; AI Operations</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="font-body text-xs text-zinc-600">
            © {new Date().getFullYear()} Before The Risk. All rights reserved.
          </div>
          <div className="font-display text-[11px] tracking-[0.3em] uppercase text-zinc-600" data-testid="footer-credit">
            Powered by{" "}
            <a
              href="https://Eternitymp.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#a2020b] hover:text-[#c0030e] transition-colors underline-offset-4 hover:underline"
              data-testid="eternity-mp-link"
            >
              Eternity MP
            </a>
          </div>
        </div>

        {/* Discreet admin entry — TEMPORARY PREVIEW GATE CONTROL */}
        <div className="mt-4 flex justify-center">
          <Link
            to="/admin"
            className="text-[10px] tracking-[0.4em] uppercase font-display text-zinc-700 hover:text-zinc-500 transition-colors"
            data-testid="footer-admin-link"
            aria-label="Admin"
          >
            ·  Admin  ·
          </Link>
        </div>
      </div>
    </footer>
  );
};
